module.exports = __webpack_public_path__ + "static/media/p5_1.079a3cc8.jpeg";